import axios from 'axios';

const state = {
  brands: []
};

const getters = {
  getBrands: state => {
    return state.brands.map(b => {
      return { text: b.name, value: b._id };
    });
  },
  getBrandsTree: state => {
    const tree = state.brands.map(b => {
      return { id: b._id, label: b.name };
    });
    return [
      { id: 'brands', label: 'Marcas', children: tree, isDefaultExpanded: true }
    ];
  }
};

const actions = {
  loadBrands: ({ commit, getters }) => {
    axios.get(`/api/brands`).then(response => {
      commit('LOAD_BRANDS_SUCCESS', response.data);
    });
  }
};

const mutations = {
  ['LOAD_BRANDS_SUCCESS']: (state, payload) => {
    state.brands = payload;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
